<app-short-code-list
 [listMode]="'linkedaccounts'"  
 [actionInterceptor]="interceptAction"
 [actionInterceptorSelf]="this"></app-short-code-list>


<app-linked-accounts-navigator>

</app-linked-accounts-navigator>
